import { gql } from '@apollo/client'
import { Domiciliation } from 'globals/models/Domiciliation'

export const CANCELLATIONS_LIST = gql`
  query cancelationsList($startingDate: ISO8601DateTime!, $endingDate: ISO8601DateTime!, $page: Int!) {
    cancelationsList(
      startingDate: $startingDate
      endingDate: $endingDate
      page: $page
    ) {
      id
      firstname
      lastname
      email
      status
      clientSince
      address {
        id
        shortname
        fullAddress
      }
      forwardingAddress {
        id
        name
        streetAddress
        postalCode
        city
        country
      }
      mailForwardingFrequency
      pendingUserMailsCount
      phoneNumber
      postalProcurationReady
      society {
        id
        name
        legalStatus
        brandName
      }
      userMailOption
      leaderEmail
      leaderPhoneNumber
    }
  }
`

export interface CancellationsListVariables {
  startingDate: string,
  endingDate: string,
  page: number
}

export interface CancellationsListResult {
  cancelationsList: Domiciliation[]
}
